import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { TradeBadge, Stars, BadgeCount } from "./Badges";
import { eur, initials } from "@/lib/hz";

export const ProCard = ({ pro }) => (
  <Link to={`/profesionales/${pro.id}`} data-testid={`pro-card-${pro.id}`}
    className="group flex flex-col rounded-2xl border border-slate-200 bg-white p-5 transition-[border-color,box-shadow,transform] hover:-translate-y-0.5 hover:border-orange-300 hover:shadow-md">
    <div className="flex items-start gap-3">
      <span className="grid size-12 shrink-0 place-items-center rounded-full bg-slate-900 font-heading font-bold text-white">{initials(pro.name)}</span>
      <div className="min-w-0 flex-1">
        <div className="font-heading text-lg font-bold text-slate-900 group-hover:text-orange-600">{pro.name}</div>
        <div className="flex items-center gap-1 text-sm text-slate-500"><MapPin className="size-3.5" />{pro.city}</div>
      </div>
      {pro.hourly_rate != null && (
        <div className="text-right"><div className="font-bold text-slate-900">{eur(pro.hourly_rate)}</div><div className="text-xs italic text-slate-500">/hora</div></div>
      )}
    </div>
    <div className="mt-3 flex flex-wrap gap-1.5">{pro.trades.map((t) => <TradeBadge key={t} trade={t} />)}</div>
    <p className="mt-3 line-clamp-2 flex-1 text-sm text-slate-600">{pro.bio}</p>
    <div className="mt-4 flex flex-wrap items-center justify-between gap-2">
      <Stars value={pro.rating} count={pro.reviews_count} />
      <div className="flex items-center gap-2">
        {pro.punctuality != null && <span className="text-xs font-semibold text-emerald-700">{pro.punctuality}% puntual</span>}
        <BadgeCount n={pro.badges?.length ?? 0} />
      </div>
    </div>
  </Link>
);
